<div class="sn-dropdown">
  <button class="btn btn-actions" title="addition action" (click)="toggleDropdown(option_list, commonParent)">
    <svg width="28" height="28">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#t-dots"></use>
    </svg>
  </button>
  <div class="sn-dropdown__body" (click)="handleClick($event, data)" #option_list [style.width]="width">
    <span
      class="sn-dropdown__option"
      *ngFor="let option of optionsList"
      [attr.data-action-name]="option.actionName"
      >{{ option.title }}</span
    >
  </div>
</div>
